<ng-container *ngIf="isCreateMode()">
  <form (ngSubmit)="save()" [formGroup]="form">
    <base-form-header
      (onClose)="close(data)"
      [mode]="mode"
      createLabel="Ajouter un établissement client"
    ></base-form-header>

    <mat-dialog-content fxLayout="column">
      <base-form-input
        label="Etablissement"
        controlName="establishment"
        type="autocomplete"
        (autocompleteChange)="establishmentAutocompleteChange($event)"
        [items$]="establishments$"
        displayProperty="label"
      ></base-form-input>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
      <base-form-input
        type="submit"
        [mode]="CrudModeEnum.Create"
        entityLabel="ESTABLISHMENT"
        (onCreate)="createItem()"
        [loading]="loading"
      ></base-form-input>
    </mat-dialog-actions>
  </form>
</ng-container>

<ng-container *ngIf="isDeleteMode()">
  <div mat-dialog-title fxLayout="row" fxLayoutAlign="space-between center">
    <div>Supprimer {{ data?.name || 'cet établissement client' }}</div>
    <button type="button" mat-icon-button (click)="close()" tabindex="-1">
      <mat-icon [icIcon]="icClose"></mat-icon>
    </button>
  </div>

  <mat-dialog-content fxLayout="column" fxLayoutGap="16px">
    <ng-container *ngIf="hasDependencies; else noDep">
      <p>Les dépendances suivantes ont été détectées :</p>
      <div *ngFor="let data of dependencies.data">
        <p *ngIf="data.dependencies.length > 0" class="font-semibold text-lg text-gray-700 mt-4 mb-2">
          {{ data.name }}
          <span class="item-badge" fxFlex="none">
            {{ data.dependencies.length }}
          </span>
        </p>
        <ul class="list-disc pl-4 max-h-40 overflow-y-auto">
          <li *ngFor="let dep of data.dependencies">{{ dep }}</li>
        </ul>
      </div>
      <p>Voulez-vous continuer la suppression ?</p>
    </ng-container>
    <ng-template #noDep>
      <p>Êtes-vous sûr de vouloir supprimer cet établissement client ?</p>
    </ng-template>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="close()">NON</button>
    <button mat-button color="primary" [loading]="loading" (click)="deleteItem()">OUI</button>
  </mat-dialog-actions>
</ng-container>
